import { buttonsFromSerializedInAppMessage as pe } from "../in-app-message-factory.js";
import InAppMessage from "./in-app-message.js";
export default class FullScreenMessage extends InAppMessage {
  constructor(
    e,
    r,
    s,
    t,
    i,
    a,
    o,
    p,
    m,
    n,
    u,
    c,
    f,
    d,
    l,
    g,
    j,
    x,
    z,
    h,
    v,
    w,
    y,
    S,
    b,
    k,
    q,
    A,
  ) {
    (p = p || InAppMessage.DismissType.MANUAL),
      (k = k || InAppMessage.Orientation.PORTRAIT),
      super(
        e,
        r,
        void 0,
        s,
        t,
        i,
        a,
        o,
        p,
        m,
        n,
        u,
        c,
        f,
        d,
        l,
        g,
        j,
        x,
        z,
        h,
        v,
        w,
        y,
        S,
        (b = b || InAppMessage.CropType.CENTER_CROP),
        k,
        q,
        A,
      ),
      (this.Te = InAppMessage.TextAlignment.CENTER);
  }
  ss() {
    return super.ss(FullScreenMessage.es);
  }
  static an(e) {
    return new FullScreenMessage(
      e[InAppMessage.hs.ea],
      e[InAppMessage.hs.ra],
      e[InAppMessage.hs.xs],
      e[InAppMessage.hs.sa],
      e[InAppMessage.hs.ta],
      e[InAppMessage.hs.URI],
      e[InAppMessage.hs.ia],
      e[InAppMessage.hs.oa],
      e[InAppMessage.hs.pa],
      e[InAppMessage.hs.ma],
      e[InAppMessage.hs.os],
      e[InAppMessage.hs.na],
      e[InAppMessage.hs.ua],
      e[InAppMessage.hs.ca],
      e[InAppMessage.hs.fa],
      e[InAppMessage.hs.da],
      e[InAppMessage.hs.la],
      e[InAppMessage.hs.ga],
      e[InAppMessage.hs.ja],
      e[InAppMessage.hs.xa],
      e[InAppMessage.hs.za],
      e[InAppMessage.hs.ha],
      e[InAppMessage.hs.va],
      pe(e[InAppMessage.hs.wa]),
      e[InAppMessage.hs.ya],
      e[InAppMessage.hs.Sa],
      e[InAppMessage.hs.ba],
      e[InAppMessage.hs.CSS],
    );
  }
}
FullScreenMessage.es = InAppMessage.qe.on;
